import { render } from "./TableTagihan.vue?vue&type=template&id=376fd990&scoped=true&ts=true"
import script from "./TableTagihan.vue?vue&type=script&lang=ts"
export * from "./TableTagihan.vue?vue&type=script&lang=ts"

import "./TableTagihan.vue?vue&type=style&index=0&id=376fd990&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376fd990"]])

export default __exports__